import React from "react";
import Card from "../../Generic/Card";
import { Wrap } from "./style";
export default function Discover() {
  return (
    <Wrap>
      <Wrap.Text>
        <Wrap.Title>Discover Our Featured Listings</Wrap.Title>
        <Wrap.Descript>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit
        </Wrap.Descript>
      </Wrap.Text>
      <Wrap.Card>
        <Card />
        <Card />
        <Card />
        <Card />
      </Wrap.Card>
    </Wrap>
  );
}
